import React from 'react';
import PropTypes from "prop-types";
import './Sections.less';

const Sections = (props) => {
    let children = props.children;
    let count = 1;
    if (Array.isArray(props.children)){
        children = [];
        for (let i = 0; i < props.children.length; i++) {
            children.push(<div className={'Section n' + i}>{props.children[i]}</div>);
        }
        count = children.length;
    }
    return (
        <div className={`Sections cargo max-${props.maxWidth} count-${count}` + (props.className == null ? '' : ' ' + props.className)}>
            {children}
        </div>
    );
}

Sections.propTypes = {
    className: PropTypes.string,
    maxWidth: PropTypes.oneOf(['400', '500', '600', '700', '800']),
};
Sections.defaultProps = {
    maxWidth: '700',
}

export default Sections;